<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BI1Pqn/image/cover.jpg?1706297466610" alt="This image is the cover for the book Mutts Spring Diaries, Mutts Kids"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mutts Spring Diaries, Mutts Kids
      </h1>
      <p class="bookDescription body article font2">
        <p>It's been a long, cold winter—Earl and Mooch are looking forward to shmelling the flowers!<br/><br/>Spring is the season of new beginnings. The birds are singing fresh concertos they’ve been working on all winter long. The caterpillars are dreaming of butterfly flight. And the bears could use that first cup of coffee after their three-month hibernation. Celebrate spring with the <i>Mutts</i> gang as they go on egg-decorating sprees, dodge playful rain showers, and welcome home the birds from their winter vacation.<br/><br/>Check out the “More to Explore” section to learn about the mysteries and wonders of the birds, who are all too happy to let you know that spring is here. You’ll find that Mooch and Earl’s feathered friends have some surprising secrets, and you won’t want to miss out on the springtime fun.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick McDonnell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07f3ec78